import { render, staticRenderFns } from "./TrialsScatter.vue?vue&type=template&id=fdfb5de8&scoped=true&"
import script from "./TrialsScatter.vue?vue&type=script&lang=js&"
export * from "./TrialsScatter.vue?vue&type=script&lang=js&"
import style0 from "./TrialsScatter.vue?vue&type=style&index=0&id=fdfb5de8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfb5de8",
  null
  
)

export default component.exports